<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import Jewel06 from './Jewel06.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ Jewel06 ],

    data () {
      return {
        excepts: [ 'ジュエルコレクション', 'ダイヤモンドコレクション' ],
      }
    },

    computed: {
      /**
       * プレゼントボックスのアイテムのうち、
       * えもコレクション開始時点から取得可能なもののみ。
       * （ダイヤモンドコレクション開始以降のものを除外）
       * @return {Object[]}
       */
      itemsPBox () {
        const query = { collection: 'プレゼントボックス' }
        const excepts = [
          'PB-51', 'PB-52', 'PB-53'       , 'PB-53:after1',
          'PB-54', 'PB-55', 'PB-55:after1', 'PB-55:after2',
          'PB-57', 'PB-58', 'PB-59'       , 'PB-60',
          'PB-62',
        ]
        return _
          .where(this.itemsFiltered, query)
          .filter(item => !excepts.includes(item.id))
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR10" />
    </template>

    <template #col2>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR モーリー限定 ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col5>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>

    <template #col6>
      <ItemList title="ジュエルパクト" color="#c598ff" :items="itemsJewelPact" />
      <ItemList title="デザインパレット自作" color="#c598ff" :items="itemsDesignPalette" />
      <ItemList title="バレンタインチャンネル" color="#a1c0fa" :items="itemsValentineChannel" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
